module.exports = __webpack_public_path__ + "static/media/bancofie.41c4e1e7.png";